import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CheckIcon from '@mui/icons-material/Check';
import makeStyles from '@mui/styles/makeStyles';
import CustomButton from 'components/CustomButton';

const useStyles = makeStyles((theme) => ({
  tooltipBox: {
    position: 'relative',
    padding: theme.spacing(5, 3),
    maxWidth: 275,
    backgroundColor: theme.palette.shades['clr-white-900'],
    borderRadius: theme.spacing(1),
    boxShadow: `0px 4px 4px 0px #CCD4DE1A,
                0px 10px 20px 0px #CCD4DE29`,
    border: `1px solid ${theme.palette.neutral['clr-200']}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  triangle: {
    position: 'absolute',
    top: '-10px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: '10px solid #003E8C',
    filter: 'drop-shadow(0px -2px 2px rgba(0, 37, 117, 0.05))',
  },
  tooltipTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  viewButton: {
    marginTop: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: theme.spacing(0.5),
    textAlign: 'center',
    padding: '6px 12px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  proctorCircle: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'box-shadow 0.2s ease-in-out',
  },
  proctorRed: {
    backgroundColor: theme.palette.danger['clr-500'],
  },
  proctorGreen: {
    backgroundColor: theme.palette.success['clr-500'],
  }
}));

const ViolationTooltip = ({ violated, setIsDialogOpen }) => {
  const classes = useStyles();

  return (
    <Box className={classes.tooltipBox}>
      <Box className={classes.triangle} />
      <Box
        className={classes.tooltipTitle}
        style={{ color: violated ? '#E2483C' : '#009970' }}
      >
        <Box
          className={`${classes.proctorCircle} ${violated ? classes.proctorRed : classes.proctorGreen
            }`}
        >
          {violated ? (
            <PriorityHighIcon sx={{ color: '#fff', width: '12px', cursor: 'pointer' }} />
          ) : (
            <CheckIcon sx={{ color: '#fff', width: '12px', cursor: 'pointer' }} />
          )}
        </Box>
        <Typography variant='h6-medium'>{violated ? 'Violation found' : 'No violation'}</Typography>
      </Box>
      <Typography variant='body01-semiBold' color='neutral.clr-900'>
        {violated
          ? 'You have violated the guidelines!'
          : 'You did not violate the guidelines!'}
      </Typography>
      <CustomButton
        sx={{ marginTop: '4px' }}
        size='medium'
        onClick={() => setIsDialogOpen(true)}
      >
        View details
      </CustomButton>
    </Box>
  );
};

export default ViolationTooltip;
